import { Dispatch, AnyAction } from 'redux';
import { ApiAction, HttpMethods } from '../models/api-model';
import { OrganizationActionTypes, OrganizationState } from '../models/organization-prc-model';
import { apiAction } from './base-api';
import { ApiEndpoint } from '../constants/api-endpoints';

const InitialState: OrganizationState = {
    organization: null,
};

export const organizationApiReducer = (state = InitialState, action: AnyAction) => {

    switch (action.type) {
        case OrganizationActionTypes.SET_ORGANIZATIONS:
            return {
                ...state,
                organization: action.payload.data,
            };

        default: return state;
    }
};

export const getOrganization = (clientNumber: string, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        url: `${ApiEndpoint.organizationPrc}/${clientNumber}`,
        onSuccess,
        onFailure,
    });
};

export const patchOrganization = (clientNumber: string, payload, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.PATCH,
        url: `${ApiEndpoint.organizationPrc}/${clientNumber}`,
        payloadData: payload,
        onSuccess,
        onFailure,
    });
};

export const getOrganizations = (onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.GET,
        url: `${ApiEndpoint.organizationPrc}/institution/institution_list/institutions`,
        onSuccess,
        onFailure,
    });
};

export const getDioceseOrganizations = (dioInstitutionId: string, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.GET,
        url: `${ApiEndpoint.miscPrc}/dioceses/${dioInstitutionId}/institutions.json`,
        onSuccess,
        onFailure,
    });
};

export const postAddOrganizationRequest = (payload, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {

    return apiAction({
        method: HttpMethods.POST,
        url: `${ApiEndpoint.miscPrc}/organizations`,
        payloadData: payload,
        onSuccess,
        onFailure,
    });
};

export const postRemoveOrganizationRequest = (institutionClientNumber: string, data: any, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {

    const requestPayload = {        
        removal_request: data,        
    };

    return apiAction({
        method: HttpMethods.DELETE,
        url: `${ApiEndpoint.miscPrc}/organizations/${institutionClientNumber}`,
        payloadData: requestPayload,
        onSuccess,
        onFailure,
    });
};

export const getBishopDetails = (onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.GET,
        url: `${ApiEndpoint.organizationPrc}/bishopDetails`,
        onSuccess,
        onFailure,
    });
};